import React from "react";

import { SingleSelectInput, Text } from "@performyard/py-components";

import { SURVEY_DETAILS_MODALS } from "../../../../SurveyDetails/store/model";
import { useSetters as useSurveyDetailsSetters } from "../../../../SurveyDetails/store/store";
import { useSetters, useSurveyAccess } from "../store/store";

import { useUserSelectionCount } from "../../../../../../../api/hooks/defs/user-selection";
import { useSurveyAccessTier } from "../../../../SurveyDetails/hooks/useSurveyAccessTier";
import { useSurvey } from "../../../hooks/useSurvey";

import { SURVEY_PARTICIPANTS_CONFIG } from "../constants";

export const SurveyAccessSelect = ({ surveyId, selectionCount }: { surveyId: string; selectionCount: number }) => {
	const { survey } = useSurvey({ surveyId });
	const surveyAccess = useSurveyAccess();
	const setters = useSetters();
	const surveyDetailsSetters = useSurveyDetailsSetters();
	const surveyUserAccess = useSurveyAccessTier(surveyId).tier;

	const { data: savedSelectionCount } = useUserSelectionCount(survey?.participantSelection?.selectionObjectId || "", {
		enabled: !!survey?.participantSelection?.selectionObjectId,
	});

	const handleChange = (value: string | null) => {
		if (!value || value === surveyAccess) {
			return;
		}
		if (surveyAccess === SURVEY_PARTICIPANTS_CONFIG.SURVEY_ACCESS.ALL_EMPLOYEES) {
			// changing from all employees to selected employees is no big deal
			setters.setSurveyAccess(SURVEY_PARTICIPANTS_CONFIG.SURVEY_ACCESS.SELECTED_EMPLOYEES);
			setters.setEditParticipants(true);
		} else if ((savedSelectionCount?.count && savedSelectionCount?.count > 0) || selectionCount > 0) {
			// changing from selected employees to all employees requires opening a warning modal
			surveyDetailsSetters.setModal(SURVEY_DETAILS_MODALS.SELECT_ALL_EMPLOYEES_MODAL);
		} else {
			setters.setSurveyAccess(SURVEY_PARTICIPANTS_CONFIG.SURVEY_ACCESS.ALL_EMPLOYEES);
			setters.setEditParticipants(false);
		}
	};

	return (
		<div className="flex w-[378px] items-center gap-4">
			<Text htmlFor="survey-access" size="paragraph-2" weight="semi-bold">
				<span className="text-nowrap">Survey Access</span>
			</Text>
			<SingleSelectInput
				options={[
					{
						label: "All employees have access",
						value: SURVEY_PARTICIPANTS_CONFIG.SURVEY_ACCESS.ALL_EMPLOYEES,
					},
					{
						label: "Only selected employees have access",
						value: SURVEY_PARTICIPANTS_CONFIG.SURVEY_ACCESS.SELECTED_EMPLOYEES,
					},
				]}
				disabled={survey?.status === "closed" || surveyUserAccess !== "edit"}
				value={surveyAccess}
				onChange={handleChange}
				isClearable={false}
				id="survey-access"
			/>
		</div>
	);
};
